import {
  DashboardId,
  DashboardList,
} from '../../common/components/dashboards/types';
import { allDashboardConfigs } from '../../settings/dashboard-configs/dashboard-configs-json';
import { Hasher } from '../hasher';
import { DomainPreferences, HasDependencies, hashString } from '../types';
import { DashboardNotFoundError } from './dashboard-errors';
import { DashboardService } from './dashboard-service';

export class FullViewDashboardService
  implements DashboardService, HasDependencies
{
  constructor(
    private readonly dashboardList: DashboardList,
    private readonly domainPreferences: DomainPreferences
  ) {}

  public getDeps = () => [
    hashString([
      Hasher.hash(this.dashboardList.dashboards),
      Hasher.hash(this.domainPreferences),
    ]),
  ];

  public listDashboards = async () => {
    return this.dashboardList.dashboards;
  };

  public listCustomDashboardConfigs = async () => {
    return allDashboardConfigs;
  };

  // TODO: This method is probably same for all dashboard-services so
  // maybe DashboardService should be an abstract class or something
  public getCustomDashboardConfig = async (dashboardId: DashboardId) => {
    const dashboardConfigs = await this.listCustomDashboardConfigs();
    const dashboardConfig =
      dashboardConfigs.find((dc) => dc.id === dashboardId) ?? null;
    if (dashboardConfig === null) {
      return new DashboardNotFoundError(dashboardId);
    } else {
      return dashboardConfig;
    }
  };
}
